export const PUBLIC_ENVIRONMENT = {
  REACT_APP_ARBITRUM_RPC_URL: process.env.REACT_APP_ARBITRUM_RPC_URL as string,
  REACT_APP_ARBITRUM_EXPLORER_URL: process.env
    .REACT_APP_ARBITRUM_EXPLORER_URL as string,
  REACT_APP_ARBITRUM_FAUCET_API_KEY: process.env
    .REACT_APP_ARBITRUM_FAUCET_API_KEY as string,
  REACT_APP_DEBUG: process.env.REACT_APP_DEBUG as string,
};
